import { isDefined } from '@sgme/fp';
import type { PropsWithChildren, ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

import type { IntlMessageId } from '@/types/intl';

interface FieldWIthLabelProps {
  formattedMessageId?: IntlMessageId;
  formattedMessageValues?: Record<string, string | boolean>;
  className?: string;
  extra?: ReactElement;
  isDisplayed?: boolean;
}

export function FormField({
  children,
  formattedMessageId,
  formattedMessageValues,
  className,
  extra,
  isDisplayed = true,
}: PropsWithChildren<FieldWIthLabelProps>): ReactElement | null {
  if (!isDisplayed) {
    return null;
  }

  const classes = `form-group form-group-sm d-flex justify-content-center align-items-center my-1${isDefined(className) ? ` ${className}` : ''}`;

  return (
    <div className={classes}>
      <div className="pe-1 col-form-label col-form-label-sm col-4 text-nowrap text-end" style={{ width: '30%' }}>
        {isDefined(formattedMessageId) && <FormattedMessage id={formattedMessageId} values={formattedMessageValues} />}
      </div>

      <div className="d-flex flex-column px-1" style={{ width: '64%' }}>
        {children}
      </div>

      <div className="badge badge-dismissible" style={{ width: '6%' }}>
        {extra}&nbsp;
      </div>
    </div>
  );
}
